import { defineStore } from 'pinia'
import axios from 'axios'
import {reactive,ref} from 'vue'
import { useRoute, useRouter } from 'vue-router'

export const usePipelineStore = defineStore('PipelineStore', {
    state: () => {
        return {
            IN_PROGRESS:'in progress',
            IN_REVIEW:'in review',
            DONE:'completed',
            toggleActiveModel: ref(false),
            pipeline_params:reactive(),
            pipeline_id:ref(),
            client_id:ref(),
            opportunities:ref([]),
            client_details:reactive(),
            statuses:ref(['In Progress','In Dispute','Completed']),
            route: useRoute(),
            router: useRouter(),
            loading:ref(true)
        }
    },
    actions: {
        async fetchOpportunities() {
            let $this = this;
            const route = this.router.resolve(
                {
                    name: 'opportunities.show'
                }
            );
            try {
                this.opportunities = await axios.post(route.href)
                .then(function (response) {
                    $this.loading = false;
                    return response.data.data;
                });
            } catch (error) {
            }
        },
    }
})
